/** Пустое состояние списков и разделов отчёта. */
export function EmptyState({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <div className="rounded-lg border border-dashed border-border-default/[0.15] bg-surface-1/50 p-8 text-center">
      <p className="text-body text-text-primary font-medium">{title}</p>
      {description ? (
        <p className="mt-2 text-label text-text-tertiary max-w-md mx-auto">{description}</p>
      ) : null}
    </div>
  );
}
